<template>
  <div class="information">
    <div class="inside">
      <div class="credits-intro">
        <p>{{ info.text.introduction[currentLang] }}</p>
      </div>

      <!-- <div class="intro-partner-container">
        <img
          class="intro-partner"
          :src="IntroPartner"
          alt="Major Partner Telstra"
          loading="lazy"
        />
      </div> -->

      <h2>{{ info.text.imageCreditsHeading[currentLang] }}</h2>

      <ul class="credit-list" role="list">
        <li
          class="credit-list__item"
          role="listitem"
          v-for="(credit, index) in info.imageCredits"
          :key="index"
        >
          <img
            class="credit-list__img"
            :src="credit.image"
            :alt="credit.text.title[currentLang]"
            loading="lazy"
          />
          <p
            class="credit-list__blurb"
            v-html="credit.text.title[currentLang]"
          ></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import IntroImage from "@/assets/images/misc/IntroductionImage.jpg";
// import IntroPartner from "@/assets/images/misc/IntroductionPartner@4x.png";
export default {
  data() {
    return {
      IntroImage,
      // IntroPartner
    };
  },
  computed: {
    ...mapState(["info", "currentLang"])
  },
  mounted() {
    document.body.classList.remove("no-scroll");
  },
  beforeDestroy() {
    document.body.classList.add("no-scroll");
  }
};
</script>

<style lang="scss">
.credits-intro {
  text-align: center;
  padding: 25px;
  max-width: 360px;
  margin: 0 auto;
  margin-top: 2em;
}

h2 {
  @include ngv-type($exhibition_subtitle, 14px, 18px);
  text-align: center;
  margin-bottom: 2em;
}

.credit-list {
  margin: 0 auto;
  list-style: none;
  padding-left: 0;
  &__item {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 25px;
    margin-bottom: 25px;
  }
  &__img {
    max-width: 180px;
    width: 100%;
    height: auto;
  }
  &__blurb {
    @include ngv-type(sans-serif, 12px, 14px);
    text-transform: none;
    max-width: 180px;
    strong {
      // em {
      display: block;
      // word-break: break-all;
      // white-space: pre;
    }
    em {
      display: inline;
    }
    span {
      display: block;
    }
  }
}

.intro-image-container {
  max-width: 768px;
  margin: 0 auto;
}
.intro-image {
  width: 100%;
  height: auto;
}
.intro-partner-container {
  max-width: 138px;
  margin: 0 auto;
}
.intro-partner {
  width: 100%;
  height: auto;
}
</style>
